import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { api } from "@/lib/api";
import { toast } from "sonner";

export default function ChangePasswordModal({ open, onClose }) {
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (next !== confirm) {
      toast.error("Las contrasenas nuevas no coinciden");
      return;
    }
    if (next.length < 4) {
      toast.error("La nueva contrasena debe tener al menos 4 caracteres");
      return;
    }
    setLoading(true);
    try {
      await api.post("/auth/change-password", { current_password: current, new_password: next });
      toast.success("Contrasena actualizada");
      setCurrent(""); setNext(""); setConfirm("");
      onClose();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "No se pudo cambiar");
    } finally { setLoading(false); }
  };

  return (
    <Dialog open={open} onOpenChange={(o) => { if (!o) onClose(); }}>
      <DialogContent data-testid="change-password-modal">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl">Cambiar mi contrasena</DialogTitle>
          <p className="text-sm text-muted-foreground">Elige una que recuerdes con facilidad.</p>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-4 mt-4">
          <div>
            <Label>Contrasena actual</Label>
            <Input data-testid="cp-current" required type="password" value={current} onChange={(e) => setCurrent(e.target.value)} className="h-11 mt-1" />
          </div>
          <div>
            <Label>Nueva contrasena</Label>
            <Input data-testid="cp-new" required type="password" value={next} onChange={(e) => setNext(e.target.value)} className="h-11 mt-1" placeholder="Minimo 4 caracteres" />
          </div>
          <div>
            <Label>Confirmar nueva contrasena</Label>
            <Input data-testid="cp-confirm" required type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} className="h-11 mt-1" />
          </div>
          <Button type="submit" data-testid="cp-submit" disabled={loading} className="w-full bg-primary hover:bg-primary/90 h-11">
            {loading ? "Guardando..." : "Actualizar contrasena"}
          </Button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
